// extracted by mini-css-extract-plugin
export var cursorDrag = "cursor-module--cursorDrag--e17ca";
export var cursorInfo = "cursor-module--cursorInfo--c0c66";
export var cursorVid = "cursor-module--cursorVid--743a4";